import React, { useState, useEffect, useRef } from 'react';
import { MetricCard, useFormatter } from 'src/mtska-frontend-app-component';
import { CircularProgress, Typography } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';

const KPIBudgetSet = ({ dataProviderName, filters: defaultFilters }) => {

    const { t } = useTranslation();
    const { formatCurrency } = useFormatter();
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [budgetOverview, setBudgetOverview] = useState();
    const [localDrawable, setLocalDrawable] = useState();

    const { item, loadOne, loading } = useDataProvider('statisticsviews/budget');
    const lastFiltersRef = useRef();

    useEffect(() => {
        const stringified = JSON.stringify(filterModel);
        if (lastFiltersRef.current !== stringified && !loading) {
            lastFiltersRef.current = stringified;
            loadOne('overview', {filters:filterModel});
        }
    }, [filterModel]);

    useEffect(() => {
        if (loading || !item || item.length == 0) {
            return
        }

        setBudgetOverview(item.data);
        setLocalDrawable(true);
    }, [loading])

    const renderRow = (yearData, showYearLabel) => {
        if (!yearData) return null;
        
        return (
            <div className="mtska-metrics-row" key={yearData._id}>
                {showYearLabel && (
                    <Typography level="h4" className="mtska-metrics-year">{yearData._id}</Typography>
                )}
                <div className="mtska-metrics-grid">
                    <MetricCard label={t('budget.centrale')} value={formatCurrency(yearData.budgetCentrale)} />
                    <MetricCard label={t('budget.centrale.eroded')} value={formatCurrency(yearData.budgetCentraleEroded)} />
                    <MetricCard label={t('budget.centrale.remaining')} value={formatCurrency(yearData.budgetCentraleRemaining)} />
                    <MetricCard label={t('budget.locale')} value={formatCurrency(yearData.budgetLocale)} />
                    <MetricCard label={t('budget.locale.eroded')} value={formatCurrency(yearData.budgetLocaleEroded)} />
                    <MetricCard label={t('budget.locale.remaining')} value={formatCurrency(yearData.budgetLocaleRemaining)} />
                </div>
            </div>
        );
    };

    return (localDrawable && budgetOverview ? 
        <div className="mtska-metrics-wrapper">
            {Array.isArray(budgetOverview) && budgetOverview.map(yearData => renderRow(yearData, budgetOverview.length > 1))}
        </div>
        :
        <CircularProgress /> 
    )
}

export default KPIBudgetSet;